import React, {useEffect, useState} from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Tab,
  Tabs,
} from '@material-ui/core';
import Page from '../../components/Page';
import ContentEventInfo from './ContentEventView/Index';
import {useParams} from 'react-router-dom';
import Loading from '../../components/Loading/Loading';
import SimpleToolbar from '../../components/Toolbar/SimpleToolbar';
import BasicsInfo from './ContentEventView/BasicsInfo';
import { api_get } from "../../utils/Api";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

const UserShow = (props) => {
  const {Link , pageLink, title, ...rest} = props;
  const {id} = useParams();
  const classes = useStyles();
  const [contentEvents, setEvents] = useState([]);
  const [currentTab, setCurrentTab] = useState('details');
  const [usersEvent, setUsersEvent] = useState([]);
  const [page, setPage] = useState(1);

  const tabs = [
    {value: 'details', label: 'Content'},
  ];

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };
  const handlePageChange = (event, page) => {
    setPage(page + 1);
  };
  useEffect(() => {
    api_get(`events/${id}`).then((result) => {
      setEvents(result.payload);
    });
    api_get(`events/${id}/users?page=${page}`).then((result)=>{
      setUsersEvent(result?.payload)
    })
  }, [page]);
  if (!Object.keys(contentEvents).length) {
    return (<Loading/>);
  }
  return (
    <div>
     <SimpleToolbar
       Link = {Link}
       pageLink = {'/contents/content-events'}
       title = {'Events'} />
      <Page
        className={classes.root}
        title="Customer Details"
      >
        <Container maxWidth={false}>
          <Box mt={3}>
            <Tabs
              onChange={handleTabsChange}
              scrollButtons="auto"
              value={currentTab}
              variant="scrollable"
              textColor="secondary"
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                />
              ))}
            </Tabs>
          </Box>
          <Divider/>
          <Box mt={3}>
            {currentTab === 'details' && <ContentEventInfo contentEvents={contentEvents} usersEvent={usersEvent} handlePageChange={handlePageChange} usersPage={page}/>}
            
          </Box>
        </Container>
      </Page>
    </div>

  );
};

export default UserShow;
